export default {
	// API_ENDPOINT: 'http://localhost:8000/api',
	API_ENDPOINT: 'https://sleepy-scrubland-72098.herokuapp.com/api',
	TOKEN_KEY: 'placeholder-token',
  }
